const restaurantBasicPlan = {
  items: [
    {
      componentName: 'groupCard',
      pageBreak: true,
      itemId: 'front',
      heading: '表紙',
      items: [
        {
          componentName: 'frontPageCard',
          itemId: 'front-title-author',
          heading: 'タイトル・作成者情報',
          data: {
            title: '事業計画書',
            subTitle: '東京スカイツリーの見える 多国籍イタリアンレストラン',
            url: '',
            companyFormat: 'freelance',
            companyName: '',
            authorName: '山田花子',
            createDate: new Date()
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'motivation',
      heading: '創業の動機',
      items: [
        {
          componentName: 'textCard',
          itemId: 'motivation-inner',
          heading: '',
          data: {
            text: 'これまでイタリアンレストランで調理師として勤務してきた。今は副調理長として、調理だけではなく食材の仕入やＰＯＳシステムの分析など、経営に関係する経験も積むことができた。数年前から独立開業を目指していたところ、蔵前駅近くにいい物件が見つかったので、思い描いていた南イタリア料理をメインとする店を開業したい。',
            minRaws: 5
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'company-profile',
      heading: '会社概要',
      items: [
        {
          componentName: 'companyProfileCard',
          itemId: 'company-profile-inner',
          heading: '',
          data: {
            companyName: '',
            establishedDate: {
              year: '',
              month: ''
            },
            ceo: '',
            capital: '',
            address: {
              postalCode: '',
              postalDetail: ''
            },
            tel: '',
            url: '',
            businessContentsSimple: ''
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'president-info',
      heading: '経営者略歴等',
      items: [
        {
          componentName: 'nameAddressCard',
          itemId: 'president-info-name-address',
          heading: '氏名・現住所',
          data: {
            address: {
              postalCode: '〒111-1111',
              postalDetail: '東京都杉並区 ○○町1-2-3'
            },
            dateOfBirth: {
              year: 1984,
              month: 12,
              day: 31
            },
            name: '山田 花子',
            gender: {
              kind: 'female',
              customText: ''
            }
          }
        },
        {
          componentName: 'jobHistoryCard',
          itemId: 'president-info-job-history',
          heading: '経歴',
          data: {
            histories: [
              {
                date: {
                  year: 2006,
                  month: 3
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: 'XXX大学観光学科卒業'
              },
              {
                date: {
                  year: 2006,
                  month: 4
                },
                termDate: {
                  year: 2017,
                  month: 11
                },
                desc: 'イタリアンレストランXXX に11年勤務 、副料理長をつとめる'
              },
              {
                date: {
                  year: 2017,
                  month: 12
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: '同レストランを退職し開業準備に専念'
              },
              {
                date: {
                  year: 2018,
                  month: 10
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: '開業予定'
              }
            ]
          }
        },
        {
          componentName: 'dateCard',
          itemId: 'president-info-opening-date',
          heading: '開業予定日',
          data: {
            date: {
              year: 2018,
              month: 10,
              day: 2
            }
          }
        },
        {
          componentName: 'textCard',
          itemId: 'president-info-opening-place',
          heading: '開業予定地',
          data: {
            text: '蔵前駅から徒歩5分。木造2階建の物件。１階15坪、2階15坪\n席数:カウンター 8席 テーブル4席 × 4名(1階) 　個室 2部屋 × 6名 (2階)'
          }
        },
        {
          componentName: 'manageExperienceCard',
          itemId: 'president-info-manage-experience',
          heading: '経営経験',
          data: {
            experienceStatus: 'inexperience',
            businessContents: '',
            stopDate: {
              year: '',
              month: ''
            }
          }
        },
        {
          componentName: 'licenceCard',
          itemId: 'president-info-licence',
          heading: '取得資格',
          data: {
            licencies: [
              { name: '調理師' },
              { name: '衛生管理者' }
            ]
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'business-contents',
      heading: '事業内容',
      items: [
        {
          componentName: 'textCard',
          itemId: 'business-contents-purpose',
          heading: '業種業態',
          data: {
            text: 'イタリアンレストラン'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-open-day-hour',
          heading: '営業日・営業時間',
          data: {
            text: 'ランチタイム : 11:00 - 15:00\nディナータイム : 18:00-23:00\n月曜定休日'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-major-article',
          heading: '主要商品',
          data: {
            text: 'ランチセット３種類　週替わり　南イタリア家庭料理　　各950円\nディナーはコース２種類　　4,000円、6,000円\nアラカルト　魚料理、肉料理、パスタなど\nドリンクはイタリアワインを中心に各種取り揃える'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-characteristic',
          heading: '特徴',
          data: {
            text: '東京スカイツリーにほど近い場所で開業予定。\n築40年の空き家を改装し、地域住民が寛げる空間と食事を提供する。\n料理は、南イタリアの家庭料理を中心とする。'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-target',
          heading: '客層/販売先',
          data: {
            text: '[ランチタイム]\nウィークデーは近隣のオフィスワーカー中心（主にOLをターゲットとする）\n土日は観光客をターゲットとする [ディナータイム]\n近隣住民、オフィスワーカー、カップル'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-acquisition-strategy',
          heading: '集客戦略',
          data: {
            text: 'インスタグラムを中心に毎日料理、飲食風景の写真を配信する。\n地元のイベントや会合には積極的に参加、出展していく。'
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'market-environment',
      heading: '市場環境',
      items: [
        {
          componentName: 'textCard',
          itemId: 'market-environment-customer',
          heading: '顧客状況',
          data: {
            text: '観光客が多いエリアではあるが、地元顧客を増やしリピート率を高める。\n若い世代が気軽に立ち寄れる価格帯と雰囲気をつくる。'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'market-environment-area-characteristics',
          heading: 'エリア特性',
          data: {
            text: '下町情緒残る雰囲気と観光スポットが豊富なエリア。\n老舗の飲食店からチェーン店まで幅広く存在する。'
          }
        },
        {
          componentName: 'textCard',
          itemId: 'market-environment-competitive-advantage',
          heading: '競合優位性',
          data: {
            text: '[競合店の状況]\n蔵前駅周辺で競合が見込まれるイタリアンは約15軒。\n・客単価は3,000円～6,000円と店によってばらつきがある\n・南イタリア料理をPRしている店は少ない\n\n前職で取引していた仕入先に加えて、信州に野菜の契約農場を確保できたので、特色ある食材を比較的低価格で揃えることができる。\n競合店は多いが、空き家を改装した店舗設計のユニークさと、\n家庭的な料理と接客で地元ファンを増やしていく。'
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'operation',
      heading: '運営',
      items: [
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-business-partner',
          heading: '取引先',
          data: {
            stakeholders: [
              {
                name: '個人顧客（飲食）',
                address: '',
                shareRate: 70,
                salesOnCreditRate: 40,
                closingAndPayment: '末日 即金/カード'
              }
            ]
          }
        },
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-supplier',
          heading: '仕入先',
          data: {
            stakeholders: [
              {
                name: '株式会社〇〇商店（魚・肉等）',
                address: '〇〇県市〇〇町1-2-3',
                shareRate: 50,
                salesOnCreditRate: 0,
                closingAndPayment: '末日　翌月末支払'
              },
              {
                name: '〇〇農場（野菜）',
                address: '〇〇県〇〇市〇〇町1-2-3',
                shareRate: 40,
                salesOnCreditRate: 0,
                closingAndPayment: '末日　翌月末支払'
              },
              {
                name: '株式会社〇〇（飲料等）',
                address: '〇〇県〇〇市〇〇町1-2-3',
                shareRate: 10,
                salesOnCreditRate: 0,
                closingAndPayment: '末日　翌月末支払'
              }
            ]
          }
        },
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-subcontractor',
          heading: '外注先',
          data: {
            stakeholders: [
              {
                name: '株式会社◯◯（ホームページ制作等）',
                address: '◯◯県◯◯市◯◯町1-2-3',
                shareRate: 100,
                salesOnCreditRate: 0,
                closingAndPayment: '末日　翌月末支払'
              }
            ]
          }
        },
        {
          //TODO:change card
          componentName: 'manpowerPlanningCard',
          itemId: 'operation-manpower-planning',
          heading: '人員計画',
          data: {
            positions: [
              {
                kind: '常勤役員',
                number: 0,
                detail: ''
              },
              {
                kind: '従業員',
                number: 2,
                detail: '正社員 0人\nアルバイト・パート従業員 2人'
              }
            ],
            salaryPayment: '末日〆、翌20日支払 (ボーナスの支給日 6月、12月)'
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'borrowing',
      heading: 'お借入の状況',
      items: [
        {
          //TODO:change card
          componentName: 'borrowerCard',
          itemId: 'borrowing-borrower',
          heading: '借入先',
          data: {
            borrowers: [
              {
                name: '◯◯銀行◯◯支店',
                howUse: '自動車ローン',
                amount: 120,
                repaymentAtYear: 60
              }
            ]
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'free',
      heading: '自由記述',
      items: [
        {
          componentName: 'textCard',
          itemId: '',
          heading: '',
          data: {
            text: '11年間のイタリアンレストランでの勤務経験で、調理技術だけではなく店舗運営も学ぶことができた。退職後、３ヶ月間イタリア全土を周遊し、地元に根付く食文化と人間関係の大切さを実感した。地元の人に愛され、地元の人が育てるレストランをつくりたい。'
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'other-document',
      heading: '別紙資料',
      items: [
        {
          componentName: 'textCard',
          itemId: '',
          heading: '',
          data: {
            text: '・損益計算書\n・資金調達計画\n・投資計画',
            minRaws: 3
          }
        }
      ]
    }
  ]
}

export default restaurantBasicPlan
